import { authSliceSelectors, useAppSelector } from "@/store";

export function useSession() {
  return useAppSelector(authSliceSelectors.selectSession);
}
